import "webpack-jquery-ui/autocomplete";
import BApp from "../../Modules/BApp";
import BDrugs from "./BDrugs";
import BForm from "../../modules/BForm";
import BRequest from "../../Modules/BRequest";

export default class BDrugsForm extends BForm
{
	static selector = () => `.profile-drugs-form`;

	static initialize()
	{
		this.addEventListeners();
	}

	static addEventListeners()
	{
		document.addEventListener("submit", event => {
			const selector = this.selector();
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();

				const form = new this(event.target.closest(this.selector()));
				form.submit();
			}
		});

		document.addEventListener("click", event => {
			const selector = `${this.selector()} [type="submit"]`;
			if (event.target.matches(`${selector}, ${selector} *`)) {
				event.preventDefault();

				const form = new this(event.target.closest(this.selector()));
				form.submit();
			}
		});
	}

	submit()
	{
		const form = new BForm(this.el);
		const data = form.getData();

		form.resetErrors();
		form.disable();

		BRequest.call(form.getMethod(), form.getURL(), data).then(response => {
			const drugs = new BDrugs(document.querySelector(BDrugs.selector()));
			if (drugs.el) {
				drugs.setHtml(response.data.templates.table);
			}

			form.el.reset();
			try {
				form.el.closest(`dialog`).close();
			} catch (error) {
				// Nevermind.
			}
		}).catch(error => {
			form.setErrorResponse(error.response);
		}).finally(() => {
			form.enable();
			BApp.refresh();
		})
	}
}
